export const AI_CONFIDENCE_THRESHOLDS = {
    AUTO_APPROVE: 0.92,
    REQUIRES_REVIEW: 0.70,
    AUTO_REJECT: 0.40,
};
export const DEFAULT_ISO_CURRENCY = 'IDR';
export const DEFAULT_LOCALE = 'id';
export const DEFAULT_TIMEZONE = 'Asia/Jakarta';
export const PPN_RATE = 0.11;
export const DEMO_TENANT_ID = 'demo-mdlz-001';
// Fallback IDs used before tenancy is loaded; real IDs come from /demo/tenancy
export const DEMO_USER_IDS = {
    BRAND_APPROVER: '2694cfb6-8bd5-4a51-a583-f4609d9cd5d7',
    DISTRIBUTOR_SUBMITTER: '2100bac4-3700-4fff-81fd-350ad74131e5',
};
export const CLAIM_TYPES = [
    'MEMO_REDEMPTION',
    'OUTLET_RETURN',
    'VISIBILITY_INCENTIVE',
    'SALES_TEAM_INCENTIVE',
    'PROMO_DISCOUNT_SUBSIDY',
    'SAMPLING_ACTIVITY',
    'DAMAGE_EXPIRY',
    'VOLUME_REBATE',
    'COOP_MARKETING',
    'NPD_LISTING',
    'TRADE_SPEND_DRAWDOWN',
    'OTHER',
];
export const CLAIM_STATUSES = [
    'DRAFT',
    'SUBMITTED',
    'AI_PROCESSING',
    'AWAITING_REVIEW',
    'UNDER_REVIEW',
    'AUTO_APPROVED',
    'APPROVED',
    'PARTIALLY_APPROVED',
    'REJECTED',
    'PAYMENT_QUEUED',
    'PAID',
    'DISPUTED',
    'CANCELLED',
];
export const DEMO_ROLES = ['brand_approver', 'brand_admin', 'distributor_submitter'];
export const CLAIM_EVIDENCE_TYPES = [
    'INVOICE_DIGITAL',
    'INVOICE_HANDWRITTEN',
    'CREDIT_MEMO_REFERENCE',
    'RECEIPT',
    'PHOTO_DISPLAY',
    'PHOTO_SHELF',
    'PHOTO_ACTIVITY',
    'PHOTO_PRODUCT',
    'PHOTO_RETURN',
    'RETAILER_ACKNOWLEDGMENT',
    'SIGNED_PROOF',
    'VOICE_NOTE',
    'VIDEO_CLIP',
    'SPREADSHEET',
    'OTHER_DOCUMENT',
];
//# sourceMappingURL=constants.js.map